<template lang="pug">
div#mm-0.mm-page.mm-slideout
  #page
    TheHeader
    router-view

  #toTop(style='display: none'): i.bi.bi-chevron-up
</template>

<script>
import TheHeader from "@/components/TheHeader"
import scripts from "@/assets/scripts-config";

import { mapState } from "vuex";

export default {
  name: 'App',
  components: {
    TheHeader
  },

  computed: {
    ...mapState(['EMPRESA'])
  },

  created() {

    this.axios.all([
      this.axios.get("/go-menu-digital"),
      this.axios.get("/go-empresa?skip=true")
    ]).then(
      this.axios.spread((menuDigital, empresa) => {
        this.$store.commit('SET_EMPRESA', empresa.data)

        const dataMenuDigital = menuDigital.data
        const categorias = Array.from(new Map(dataMenuDigital.map(item => [item.grupo.id, item.grupo])).values())

        if (this.EMPRESA.bodegas) {
          const bodegas = Array.from(new Map(dataMenuDigital.map(item => [item.bodega.id, item.bodega])).values())
          this.$store.commit('SET_BODEGAS', bodegas)
        }

        this.$store.commit('SET_CATEGORIAS', categorias)
        this.$store.commit('ITEMS_MENU', dataMenuDigital)
      })
    );
  },

  mounted() {
    scripts()
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },

    eliminaMarcasDuplicadas(arr) {
      const marcasMap = arr.map((marca) => {
        return [marca.id_marca, marca];
      });

      return [...new Map(marcasMap).values()];
    },
  }
}
</script>